module.exports = __webpack_public_path__ + "fonts/dFanZfeM_74wlPZtksIFaj8CIHCZWXB3X6_0fw.woff2";